import * as React from 'react';

const SVGWarning: React.SFC<SvgProps> = props => (
  <svg width={18} height={17} {...props}>
    <path
      d="M10.367 1.06l6.602 12.402a2 2 0 0 1-1.766 2.94H2a2 2 0 0 1-1.765-2.94L6.836 1.06a2 2 0 0 1 3.531 0zm-.883.47a1 1 0 0 0-1.765 0L1.117 13.932A1 1 0 0 0 2 15.402h13.203a1 1 0 0 0 .883-1.47L9.484 1.53zm-.841 9.708a.48.48 0 0 1-.479-.445l-.338-4.677a.818.818 0 1 1 1.633 0l-.338 4.677a.48.48 0 0 1-.478.445zm.029 2.34a.93.93 0 1 1 0-1.86.93.93 0 0 1 0 1.86z"
      fill="#C00"
      fillRule="nonzero"
    />
  </svg>
);

export default SVGWarning;
